import React from 'react'
import { Search } from 'lucide-react'

const SearchBox = ({ placeholder, value, onChange }) => {
  return (
    <div className="search-input-wrapper">
          <Search className="search-icon-left" />
          <input
            type="text"
            placeholder={placeholder}
            className="camera-search-field"
            value={value}
            onChange={onChange}
          />
        </div>
  )
}

export default SearchBox